import { render, staticRenderFns } from "./AddToBlacklists.vue?vue&type=template&id=625b8c96&"
import script from "./AddToBlacklists.vue?vue&type=script&lang=js&"
export * from "./AddToBlacklists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports